import React, {useState} from 'react';
import {connect} from "react-redux";
import PropTypes from "prop-types";
import { numToLetter} from "../../../../../../helpers/sqftHelper";
import {iconHeight, iconLength, iconLink} from "../../../../../../assetsSQFT";
import {changeMiteredSection} from "../../../../../../../../actions/sqftMiteredFunctions";
import workspace from "../../../../../canvas/core/workspace";
import {updateSQFTCalculations} from "../../../../../../../../actions/sqftFunctions";
import SlabWorkspace from "../../../../../canvas/core/slab/slabWorkspace";
import config from "../../../../../canvas/store/sqftConfig";
import {FormattedMessage} from "react-intl";
import {hardCodeIsDeStefano} from "../../../../../../../../misc/fabricatorHardcode";
import sqftConfig from "../../../../../canvas/store/sqftConfig";

const MIN_LOGICAL_VALUE = hardCodeIsDeStefano() ? 40 : 1;
const MAX_VALUE = sqftConfig.measureUnit === "Metric" ? 1500 : 700;

const SqftNavCustomBacksplashSegment = (props) => {
  const {backsplash, index} = props;
  const {updateCalculations, updateSQFTCalculations} = props;

  const line = workspace.getLineById(backsplash.attachedToId);
  const backsplashHeight = line.getBacksplashHeight();
  const lineLength = config.measureUnit === "Imperial" ? line.getLineLength() : line.getLineLengthMm(); //getTransformedMeasureUnit(15);
  const segmentMaxLength = 10000;
  const [heightInput, setHeightInput] = useState(backsplashHeight);

  const changeLength = (value) => {
    void value
  }

  const fixValue = (valStr) => {
    const val = parseFloat(valStr);
    if (isNaN(val)) return MIN_LOGICAL_VALUE;
    if (val < MIN_LOGICAL_VALUE) return MIN_LOGICAL_VALUE;
    if (val > MAX_VALUE) return MAX_VALUE;
    return val;
  };

  const onBlurHeight = () => {
    const fixed = fixValue(heightInput);
    line.setBacksplashHeight(fixed);
    setHeightInput(fixed.toString());
    updateSQFTCalculations(updateCalculations + 1);
    SlabWorkspace.slabAdditionalShapes.removeActiveBacksplashByLine(line);
  };

  return (
    <ul className="mitered-segment mitered-segment--double" data-id="${segment.id}">
      <li className="mitered-segment__content segment-height">
        <div className="segment-letter">{numToLetter(index + 1)}</div>
        <div className="segment-image">
          <img src={iconHeight} alt=""/>
        </div>
        <div className="segment-value">
          <input className="ui-input segment-value-input"
                 type="number"
                 min={MIN_LOGICAL_VALUE}
                 onFocus={e => e.target.select()}
                 onChange={e => setHeightInput(e.target.value)}
                 placeholder={heightInput}
                 onBlur={onBlurHeight}
                 value={heightInput} />
        </div>
        <div className="segment-description">
          <div>
            <img src={iconLink} alt=""/>
          </div>
          <div>
            <FormattedMessage id={"sqft.navigation.mitered.height"}/>
          </div>
        </div>
      </li>
      <li className="mitered-segment__content segment-length">
        <div className="segment-image">
          <img src={iconLength} alt=""/>
        </div>
        <div className="segment-value">
          <input type="number"
                 max={segmentMaxLength}
                 min="0"
                 className="ui-input segment-value-input"
                 placeholder={lineLength}
                 value={lineLength}
                 disabled={true}
                 onFocus={e => e.target.select()}
                 onChange={(e) => changeLength(e.target.value)} />
        </div>
        <div className="segment-description">
          <FormattedMessage id={"sqft.navigation.mitered.length"}/>
        </div>
      </li>
    </ul>
  );
};

SqftNavCustomBacksplashSegment.propTypes = {
  backsplash: PropTypes.object,
};

const mapStateToProps = (store) => {
  return {
    menuOpened: store.sqftMenuState.menuOpened,
    updateCalculations: store.sqftState.updateCalculations,
  };
};

const mapDispatchToProps = {
  changeMiteredSection,
  updateSQFTCalculations,
};


export default connect(mapStateToProps, mapDispatchToProps)(SqftNavCustomBacksplashSegment);
